
import { Vue, Component } from 'vue-property-decorator';
import PriceAdjust from './ManualBooking/PriceAdjust/PriceAdjust';

@Component({
  name: 'Spa',
  components: {
    PriceAdjust,
  },
})
export default class Spa extends Vue {

}
